module.exports = __webpack_public_path__ + "static/media/industries.5925e1aa.jpg";